import store from '@/store';

export default {
    install(Vue) {

        Vue.prototype.$selectOdd = function (odd) {

            // console.log(odd);

            // Verifica se já existe este evento no cupom;
            const verify_event = store.state.coupons.some(
                (item) => item.id_event == odd.id_event
            );

            // Verifica se já existe esta odd no cupom;
            const verify_odd = store.state.coupons.some(
                (item) => item.id_odd == odd.id_odd
            );

            // Não Existe o evento, pode inserir a odd
            if (!verify_event) {
                // Inserte Odd
                store.state.coupons.push(odd);

                // Register Event add_to_cart Analytics
                Vue.prototype.$gtag.add_to_cart(odd);
            } else {

                // Existe o Evento e Existe a Odd no Cupom
                if (verify_event && verify_odd) {

                    // Remove a Odd do Cupom
                    store.state.coupons = store.state.coupons.filter(
                        (item) => item.id_odd !== odd.id_odd
                    );

                    // Register Event remove_from_cart Analytics
                    Vue.prototype.$gtag.remove_from_cart(odd);

                    // Existe o Evento, mas, não existe esta Odd
                    // Substitui a Odd
                } else if (verify_event && !verify_odd) {
                    store.state.coupons.some((item, index) => {
                        if (item.id_event == odd.id_event) {
                            store.state.coupons.splice(index, 1, odd);
                        }
                    });
                }
            }

        }
    }
}
